module.exports = __webpack_public_path__ + "img/zzbLog.ce6aea22.png";